import { render, staticRenderFns } from "./add-company-modal.vue?vue&type=template&id=f4796544&scoped=true"
import script from "./add-company-modal.vue?vue&type=script&lang=js"
export * from "./add-company-modal.vue?vue&type=script&lang=js"
import style0 from "./add-company-modal.vue?vue&type=style&index=0&id=f4796544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4796544",
  null
  
)

export default component.exports